// extracted by mini-css-extract-plugin
module.exports = {"text_bold":"feedback_text_bold__2qnlv","text":"feedback_text__3UQQc","list_item":"feedback_list_item__3qYx4","close_btn_box":"feedback_close_btn_box__3Ed3o"};